import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getLaunchRouteFromNativeUrl, registerNativeUrlListener } from "@/lib/mobile-runtime";

const MobileAppBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let disposed = false;
    let removeListener: (() => void) | null = null;

    void (async () => {
      const initialRoute = await getLaunchRouteFromNativeUrl();
      if (!disposed && initialRoute) {
        navigate(initialRoute, { replace: true });
      }

      const cleanup = await registerNativeUrlListener((route) => {
        navigate(route, { replace: true });
      });

      if (disposed) {
        cleanup();
        return;
      }

      removeListener = cleanup;
    })();

    return () => {
      disposed = true;
      removeListener?.();
    };
  }, [navigate]);

  return null;
};

export default MobileAppBridge;
